const detectServerBaseUrl = (req) => {
    const HEADER_XOH = 'x-original-host';
    const HEADER_XOH_JPCN = 'x-originalhost';
    const HEADER_XFH = 'x-forwarded-host';
    const protocol = req?.connection?.encrypted ? 'https' : 'http';
    let baseURL;
    if (req?.headers?.[HEADER_XOH_JPCN]) {
        baseURL = `${protocol}://${req.headers[HEADER_XOH_JPCN]}`;
    }
    else if (req?.headers?.[HEADER_XOH]) {
        baseURL = `${protocol}://${req.headers[HEADER_XOH]}`;
    }
    else if (req?.headers?.[HEADER_XFH]) {
        baseURL = `${protocol}://${req.headers[HEADER_XFH]}`;
    }
    else if (req?.headers?.host) {
        baseURL = `${protocol}://${req.headers.host}`;
    }
    else if (req?.connection?.remoteAddress) {
        baseURL = `${protocol}://${req.connection.localAddress}:${req.connection.localPort}`;
    }
    return baseURL;
};
const extractTLD = (domain) => {
    const elems = domain.split('.');
    return elems.at(-1);
};
const extractRootDomain = (domain) => {
    // const domain = neurlw URL(url).hostname
    const elems = domain.split('.');
    // handle localhost usecase
    if (elems.length === 1) {
        return elems[0];
    }
    const iMax = elems.length - 1;
    const elem1 = elems[iMax - 1];
    const elem2 = elems[iMax];
    const isSecondLevelDomain = iMax >= 3 && (elem1 + elem2).length <= 5;
    return (isSecondLevelDomain ? elems[iMax - 2] + '.' : '') + elem1 + '.' + elem2;
};
const extractHostname = (url = '') => {
    try {
        return new URL(url).hostname;
    }
    catch (e) {
        return '';
    }
};
/* Check if string is IP */
const checkIfValidIP = (str) => {
    // Regular expression to check if string is a IP address
    const regexExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
    const ip = extractIP(str);
    return regexExp.test(ip);
};
const extractIP = (str) => {
    // http://www.regular-expressions.info/examples.html
    const r = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/;
    const t = str.match(r);
    return !t ? '' : t[0];
};
const findCookieDomain = (str = '', useFullDomainCookies = false) => {
    // detect cookie domain
    let cookieDomain;
    const hostname = extractHostname(str);
    if (checkIfValidIP(hostname)) {
        cookieDomain = extractIP(hostname);
    }
    else if (useFullDomainCookies) {
        cookieDomain = hostname;
    }
    else {
        cookieDomain = extractRootDomain(hostname);
        cookieDomain = `.${cookieDomain}`;
    }
    // console.log('*******************')
    // console.log(`Hostname: ${hostname}`)
    // console.log(`Domain: ${cookieDomain}`)
    return cookieDomain;
};
const findTLD = (str = '') => {
    let tld;
    const hostname = extractHostname(str);
    if (checkIfValidIP(hostname)) {
        tld = extractIP(hostname);
    }
    else {
        tld = extractTLD(hostname);
    }
    return tld;
};

const COOKIE_DEFAULT_SETTINGS = {
    path: '/',
    secure: true,
    sameSite: 'Strict',
    domain: undefined,
};
const mergeCookieSettings = (cookieSettings = {}) => {
    return Object.assign({}, COOKIE_DEFAULT_SETTINGS, cookieSettings);
};

const CUSTOM_AXIOS_ERRORS = {
    CommerceToolsAxiosError: 'CommerceToolsAxiosError',
    ElasticSearchAxiosError: 'ElasticSearchAxiosError',
    SignalStarAxiosError: 'SignalStarAxiosError',
    PdfAxiosError: 'PdfAxiosError',
    ContentStackAxiosError: 'ContentStackAxiosError',
    SalesforceAxiosError: 'SalesforceAxiosError',
    ProductsAxiosError: 'ProductsAxiosError',
};

const CLOUDFLARE_HEADERS = {
    CLIENT_IP: 'cf-connecting-ip',
    CLIENT_COUNTRY: 'cf-ipcountry',
    CLIENT_REGION_CODE: 'cf-region-code',
};
const COUNTRY_CODE = {
    IE: 'IE',
};
const REGION_CODE = {
    NIR: 'NIR',
};
function extractCloudflareHeaders(headers) {
    const fallbackCountryCode = 'US';
    const languageCode = 'en';
    let cfCountryCodeHeader = headers[CLOUDFLARE_HEADERS.CLIENT_COUNTRY]?.toString().toUpperCase() ?? fallbackCountryCode;
    const cfRegionCodeHeader = headers[CLOUDFLARE_HEADERS.CLIENT_REGION_CODE]?.toString().toUpperCase() ?? undefined;
    const cfClientIP = headers[CLOUDFLARE_HEADERS.CLIENT_IP]?.toString() ?? undefined;
    if (cfRegionCodeHeader === REGION_CODE.NIR) {
        cfCountryCodeHeader = COUNTRY_CODE.IE;
    }
    return { countryCode: cfCountryCodeHeader, languageCode, clientIP: cfClientIP };
}

export { CUSTOM_AXIOS_ERRORS, detectServerBaseUrl, extractCloudflareHeaders, findCookieDomain, findTLD, mergeCookieSettings };
//# sourceMappingURL=index.es.js.map
